
export class PathMap {
	public poly: google.maps.Polyline;
	public doors = [];
	public meters = [];
}

